const SCALE_FACTOR = 0.8;
export const SIGNATURE_FONT = 'Madefor';

export function calculateTextSize(text: string, ctx: CanvasRenderingContext2D) {
  const { width, actualBoundingBoxAscent, actualBoundingBoxDescent } =
    ctx.measureText(text);

  return {
    width,
    height: actualBoundingBoxAscent + actualBoundingBoxDescent,
    offsetY: actualBoundingBoxAscent,
  };
}

export function calculateFontSize(text: string, canvas: HTMLCanvasElement) {
  const ctx = canvas.getContext('2d')!;
  const width = canvas.offsetWidth || canvas.width;
  const height = canvas.offsetHeight || canvas.height;
  const maximumHeight = height * SCALE_FACTOR;
  const maximumWidth = width * SCALE_FACTOR;

  ctx.font = `${maximumHeight}px ${SIGNATURE_FONT}`;

  const { width: widthAtFullSize, height: heightAtFullSize } =
    calculateTextSize(text, ctx);
  const maximumFontSizeByWidth =
    maximumHeight / (widthAtFullSize / maximumWidth);
  const maximumFontSizeByHeight =
    maximumHeight / (heightAtFullSize / maximumHeight);
  return Math.min(maximumFontSizeByWidth, maximumFontSizeByHeight);
}

export function writeTextOnCanvas(
  canvas: HTMLCanvasElement,
  newText: string,
  color: string = 'black',
  rtl = false,
  backgroundColor?: string,
) {
  const ctx = canvas.getContext('2d')!;
  const fontSize = calculateFontSize(newText, canvas);

  ctx.font = `${fontSize}px ${SIGNATURE_FONT}`;
  ctx.textBaseline = 'top';

  const width = canvas.offsetWidth || canvas.width;
  const height = canvas.offsetHeight || canvas.height;
  const {
    width: textWidth,
    height: textHeight,
    offsetY: textOffsetY,
  } = calculateTextSize(newText, ctx);

  if (backgroundColor) {
    ctx.fillStyle = backgroundColor;
    ctx.fillRect(0, 0, width, height);
  } else {
    ctx.clearRect(0, 0, width, height);
  }
  ctx.fillStyle = color;
  const left = (width - textWidth) / 2;
  ctx.fillText(
    newText,
    rtl ? width - left : left,
    (height - textHeight) / 2 + textOffsetY,
  );
}
